import { render, staticRenderFns } from "./historyPage.vue?vue&type=template&id=6cb95651&scoped=true&"
import script from "./historyPage.vue?vue&type=script&lang=js&"
export * from "./historyPage.vue?vue&type=script&lang=js&"
import style0 from "./historyPage.vue?vue&type=style&index=0&id=6cb95651&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb95651",
  null
  
)

export default component.exports